import React from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AuthLayout from "./AuthLayout";

function Unauthorized() {
  return (
    <AuthLayout subtitle="Unauthorized access">
      <Stack alignItems="center" spacing={2} sx={{ mt: 4, textAlign: "center" }}>
        <Typography sx={{ fontWeight: 600, color: "text.secondary" }}>
          You do not have permission to view this page.
        </Typography>
        <Button component={Link} to="/" variant="contained" size="large">
          Return home
        </Button>
      </Stack>
    </AuthLayout>
  );
}

export default Unauthorized;
